<template>
  <div class="app">
    <div class="banner-section">
      <img
        class="pattern-container"
        :src="require('@/assets/img/pattern-home.svg')"
        alt="pattern-image"
      />
      <img
        class="image-container"
        :src="require('@/assets/img/character.png')"
        alt="banner-image"
      />
      <div class="banner-text d-flex flex-column justify-center white--text">
        <div class="banner-text-two">
          <div class="display-4 huge-font">PPDB</div>
          <div class="font-weight-bold small-font">
            Penerimaan Peserta Didik Baru
          </div>
          <div class="display-1 font-weight-bold medium-font my-2">
            SMK RADEN UMAR SAID
          </div>
          <div class="display-1 font-weight-medium small-font">
            tahun pelajaran 2024/2025
          </div>
        </div>
        <v-btn class="mt-15 btn-register" depressed @click="scroll"
          >Daftar</v-btn
        >
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "BannerSection",
  methods: {
    scroll() {
      try {
        document.getElementById("major-section").scrollIntoView({
          behavior: "smooth",
        });
      } catch (e) {
        document.getElementById("closed-wave").scrollIntoView({
          behavior: "smooth",
        });
      }
    },
  },
};
</script>


<style scoped>
.banner-section {
  height: 650px;
  position: relative;
}

.banner-text-two .small-font {
  font-size: 2rem !important;
  letter-spacing: 0.2rem !important;
}

.image-container {
  height: 80%;
  position: absolute;
  right: 5rem;
  bottom: 0;
}

.pattern-container {
  height: 80%;
  position: absolute;
  right: 0;
  top: 0;
}

.btn-register {
  background: #fd8061 !important;
  color: white !important;
  text-transform: unset !important;
  width: 11rem !important;
  font-size: 1.3rem !important;
  box-shadow: 15px 27px 29px rgba(253, 128, 97, 0.2) !important;
  border-radius: 10px !important;
  height: 3.5rem !important;
}

.banner-text {
  z-index: 1;
  width: 84%;
  margin: 0 auto;
  height: 100%;
  color: #24305e !important;
  transform: translateY(-5%);
}

.banner-text-two .huge-font {
  font-size: 9rem !important;
  letter-spacing: 10px !important;
  font-weight: 800 !important;
  line-height: 9rem !important;
}

.banner-text-two .medium-font {
  letter-spacing: 3px !important;
}

@media screen and (max-width: 1375px) {
  .banner-section {
    height: 500px;
    position: relative;
  }
}

@media screen and (max-width: 1232px) {
  .image-container {
    height: 70%;
    position: absolute;
    right: 3rem;
    bottom: 0;
  }

  .banner-text-two .huge-font {
    font-size: 6rem !important;
    letter-spacing: 10px !important;
    font-weight: 800 !important;
    line-height: 7rem !important;
  }

  .banner-text-two .medium-font {
    font-size: 2rem !important;
    letter-spacing: 1px;
  }

  .banner-text-two .small-font {
    font-size: 1.5rem !important;
    letter-spacing: 1px !important;
  }
}

@media screen and (max-width: 995px) {
  .banner-section {
    height: 400px;
    position: relative;
  }

  .banner-text {
    z-index: 1;
    width: 84%;
    margin: 0 auto;
    height: 100%;
    color: #24305e !important;
    transform: translateY(0);
  }

  .image-container {
    height: 70%;
    position: absolute;
    right: 2rem;
    bottom: 0;
  }

  .banner-text-two .huge-font {
    font-size: 5rem !important;
    line-height: 5rem !important;
  }

  .banner-text-two .medium-font {
    font-size: 1.5rem !important;
  }

  .banner-text-two .small-font {
    font-size: 1.3rem !important;
  }
}

@media screen and (max-width: 778px) {
  .banner-section {
    height: 350px;
    position: relative;
  }

  .banner-text {
    z-index: 1;
    width: 84%;
    margin: 0 auto;
    height: 100%;
    color: #24305e !important;
    transform: translateY(0);
  }

  .image-container {
    height: 70%;
    position: absolute;
    right: 2rem;
    bottom: 0;
  }

  .banner-text-two .huge-font {
    font-size: 5rem !important;
    line-height: 5rem !important;
  }

  .banner-text-two .medium-font {
    font-size: 1.2rem !important;
  }

  .banner-text-two .small-font {
    font-size: 1rem !important;
  }

  .banner-text-two {
    transform: translateY(15%);
  }
}

@media screen and (max-width: 666px) {
  .image-container {
    visibility: hidden;
  }

  .pattern-container {
    height: 80%;
    position: absolute;
    right: 0;
    top: 0;
  }

  .banner-text-two {
    transform: translateY(20%);
  }

  .banner-text-two .medium-font {
    margin: 0 !important;
  }
}

@media screen and (max-width: 450px) {
  .pattern-container {
    height: 70%;
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>